import script from "./AddAnAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAnAccount.vue?vue&type=script&setup=true&lang=js"

import "./AddAnAccount.vue?vue&type=style&index=0&id=14332608&lang=css"

const __exports__ = script;

export default __exports__